import {IElementQuestionMatchPair} from '../incase-domain/elements/question/questionMatchPair';

export const checkIfPairIsCorrect = (
    element: IElementQuestionMatchPair,
    leftSelectedElement?: string,
    rightSelectedElement?: string
): boolean => element.pairs?.some((x) => x.leftElementId === leftSelectedElement && x.rightElementId === rightSelectedElement);

export const countCorrectPairs = (
    element: IElementQuestionMatchPair,
    submittedPairs: {leftSelectedElement: string; rightSelectedElement: string}[]
): number => submittedPairs.filter((pair) => checkIfPairIsCorrect(element, pair.leftSelectedElement, pair.rightSelectedElement)).length;

export const countPairsCorrectness = (
    element: IElementQuestionMatchPair,
    submittedPairs: {leftSelectedElement: string; rightSelectedElement: string}[]
): number[] => {
    const correctPairsCount = countCorrectPairs(element, submittedPairs);
    const incorrectPairsCount = submittedPairs.length - correctPairsCount;
    return [correctPairsCount, incorrectPairsCount];
};

export const checkIfAllPairsAreCorrect = (
    element: IElementQuestionMatchPair,
    submittedPairs: {leftSelectedElement: string; rightSelectedElement: string}[]
): boolean => countCorrectPairs(element, submittedPairs) === element.pairs?.length;
